var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'ftn-loader',
    ("ftn-loader_color-" + _vm.color),
    ("ftn-loader_size-" + _vm.size) ]})}
var staticRenderFns = []

export { render, staticRenderFns }